<template>
  <form class="text-md-left" v-on:submit.prevent="onSubmit">
    <alert v-show="showAlert"
      alertClass="m-b-25 alert-dismissible"
      type="danger">
      <span class="text-capitalize">{{errorResponse}}</span>
    </alert>
    <div class="row">
      <form-group formGroupClass="col-md-12" v-bind:error="formErrors.first('number')">
        <label class="form-control-label">Credit card number</label>
        <input type="text" class="form-control" v-model="card.number">
      </form-group>
    </div>
    <div class="row">
      <form-group formGroupClass="col-md-12" v-bind:error="formErrors.first('name')">
        <label class="form-control-label">Name on card</label>
        <input type="text" class="form-control" v-model="card.name">
      </form-group>
    </div>
    <div class="row">
      <form-group formGroupClass="col-md-4" v-bind:error="formErrors.first('expiration_month')">
        <label class="form-control-label">Expire month</label>
        <input type="text" class="form-control" placeholder="MM" maxlength="2" v-model="card.expiration_month">
      </form-group>
      <form-group formGroupClass="col-md-4" v-bind:error="formErrors.first('expiration_year')">
      <label class="form-control-label">Expire year</label>
        <input type="text" class="form-control" placeholder="YYYY" maxlength="4" v-model="card.expiration_year">
      </form-group>
      <form-group formGroupClass="col-md-4" v-bind:error="formErrors.first('security_code')">
      <label class="form-control-label">CVV code</label>
        <input type="password" class="form-control" placeholder="CVV" autocomplete="off" autocorrect="off" spellcheck="off" autocapitalize="off" maxlength="4" v-model="card.security_code">
      </form-group>
    </div>
    <loading-button
      v-bind:isSubmiting="isSubmiting"
      v-on:click.native="onClickPayButton"
      class="text-uppercase btn-block btn-lg m-t-10">
      <i class="icon md-lock" aria-hidden="true" v-show="!isSubmiting"></i> {{`Pay ${ credit.toLocaleString() } THB`}}
    </loading-button>
    <div class="payment-logos m-t-10">
      <img src="/static/images/omise.png" alt="Omise">
      <img src="/static/images/creditcard.png" alt="Mc visa acceptance" class="pull-xs-right">
    </div>
  </form>
</template>

<script>
import axios from 'axios';
import { Validator } from 'vee-validate';
import Alert from 'components/Alert';
import FormGroup from 'components/forms/FormGroup';
import LoadingButton from 'components/LoadingButton';

export default {
  components: {
    Alert,
    FormGroup,
    LoadingButton,
  },
  props: {
    credit: {
      type: Number,
      default: 0,
    },
  },
  data: function() {
    return {
      showAlert: false,
      validator: null,
      formErrors: null,
      errorResponse: null,
      isSubmiting: false,
      card: {
        name: null,
        number: null,
        expiration_month: null,
        expiration_year: null,
        security_code: null,
      },
    };
  },
  created: function() {
    this.validator = new Validator();
    this.validator.attach('name', 'required', { prettyName: 'Name on card' });
    this.validator.attach('number', 'required|credit_card', { prettyName: 'Card number' });
    this.validator.attach('expiration_month', 'required|digits:2|date_format:MM', { prettyName: 'Expire month' });
    this.validator.attach('expiration_year', 'required|digits:4|date_format:YYYY', { prettyName: 'Expire year' });
    this.validator.attach('security_code', 'required|numeric', { prettyName: 'CVV code' });

    this.validator.errorBag.errors = [];
    this.$set(this, 'formErrors', this.validator.errorBag);

    Omise.setPublicKey(process.env.OMISE.PUBLIC_KEY);
  },
  methods: {
    onSubmit: function() {
    },
    onClickPayButton: function() {
      this.validator.validateAll({
        name: this.card.name,
        number: this.card.number,
        expiration_month: this.card.expiration_month,
        expiration_year: this.card.expiration_year,
        security_code: this.card.security_code,
      })
      .then((success) => {
        if (!success) {
          return;
        }

        this.isSubmiting = true;

        Omise.createToken('card', this.card, (statusCode, response) => {
          if (statusCode === 200) {
            this.showAlert = false;

            this.sendPaymentRequest(response.id, this.credit);
          } else {
            this.isSubmiting = false;
            this.showAlert = true;

            this.errorResponse = response.message;
          }
        });
      }).catch(() => {});
    },
    sendPaymentRequest: function(omiseToken, credit) {
      axios.post(`/api/payment/omise`, {
        token: omiseToken,
        credit: credit,
      })
      .then((response) => {
        this.isSubmiting = false;

        window.location = response.data.authorize_uri;
      })
      .catch((error) => {
        this.isSubmiting = false;
        this.showAlert = true;

        this.errorResponse = error.response.data.failure_message;
      });
    },
    clearForm() {
      this.card.name = null;
      this.card.number = null;
      this.card.expiration_month = null;
      this.card.expiration_year = null;
      this.card.security_code = null;

      this.clearFormErrors();
    },
    clearFormErrors() {
      this.formErrors.clear();
    },
  },
};
</script>

<style lang="scss" scoped>
.payment-logos {
  height: 35px;

  img {
    vertical-align: middle;
    max-height: 100%;
    max-width: 50%;
  }
}

.form-group {
  margin-bottom: 10px;

  .form-control-label {
    margin-bottom: 0;
  }
}
</style>



// WEBPACK FOOTER //
// OmiseForm.vue?326c1cd4